module.exports = __webpack_public_path__ + "static/carolyn-8665422b4bbe244d2e3487797c133cc6.jpg";